import React, {Component} from 'react'
import fire from '../../../database/firebase'
import styled from 'styled-components'
import ClipLoader from "react-spinners/ClipLoader";
import { GithubPicker } from 'react-color';
import CountUp from 'react-countup';

const Styles = styled.div `

    // - - - - - - - - - CAMPAIGN FULL PAGE - - - - - - - - - - - - //

.campaignFullPage {
    height: 70vh;
}

    // - - CAMPAIGN SELECTED OPTIONS CARROT - - //

.campaignSelectedOptionsCarrot h4 {
    margin-top: 0px;
    margin-left: 2.5%;
    font-family: gabarito;
}

    // - - CAMPAIGN OPTION CATEGORIES - - //

.campaignOptionCategories h3 {
    font-family: gabarito;
    color: #0930cb;
}

    // - - CHALLENGES CONTAINER - - //

.challengesContainer {
    margin-top: 1.5%;
    margin-bottom: 4.5%;
}

.challengesContainer:after {
    content: "";
    display: table;
    clear: both;
}

.challengeBox {
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    text-align: left;
    width: 27.5%;
    margin-right: 5%;
    float: left;
    // margin-left: 0.5%;
    height: 36vh;
    position: relative;
    cursor: pointer;
}

.challengeBox:hover {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox2:hover {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox2:hover .innerChallengeBox2 {
    color: white;
}

.challengeBox:hover h4 {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox h1 {
    margin-top: 2.5%;
    margin-bottom: 0px;
    margin-left: 4%;
    font-size: 50px;
}

.challengeBox h4 {
    margin-top: 1%;
    margin-bottom: 2.5%;
    margin-left: 4%;
    font-family: arvo;
    color: #0930cb;
}

.challengeBox h2 {
    // margin-top: 3%;
    // margin-left: 4%;
    font-family: Arvo;
    font-size: 30px;
    margin-bottom: 2.5%;
    position: absolute;
    left: 4%;
    bottom: 3%;
    // color: black;
}

    // - - CHALLENGE BOX 2 - - //

.challengeBox2 {
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    text-align: left;
    width: 27.5%;
    margin-right: 5%;
    float: left;
    // margin-left: 0.5%;
    position: relative;
    cursor: pointer;
}

.challengeBox2 h1 {
    margin-left: 3%;
    font-size: 40px;
}

.challengeBox2 h2 {
    margin-left: 3%;
    font-family: Arvo;
    font-size: px;
    margin-bottom: 2.5%;
}

.challengeBox2 label {
    font-size: 15px;
    font-family: gabarito;
    color: #0930cb;
}

    // - - - - - - - - CUSTOMER INFORMATION - - - - - - - - //

.customerInformation {
    overflow-x: hidden;
    overflow-y: scroll;
    height: auto;
}

.customerInformation h2 {
    font-family: gabarito;
    color: #0930cb;
    margin-top: 3%;
    margin-left: 0.25%;
}

.customerInfoSection {
    width: 100%;
}

.customerInfoSection:after {
    content: "";
    display: table;
    clear: both;
}

.customerInfoSectionCol {
    float: left;
    width: 50%;
    text-align: center;
}

.customerInfoSectionCol2 {
    position: relative;
    float: left;
    width: 50%;
    text-align: center;
    height: 40vh;
    padding-bottom: 3%;
}

.customerInfoSectionPublishBtn {
    width: 100%;
    text-align: right;
}

.customerInfoSectionConfirmationBtn {

}

.customerInfoSectionPublishBtn button {
    width: 25%;
    margin-right: 15%;
    color: white;
    font-family: arvo;
    background-color: #0930cb;
    border: 2px solid #0930cb;
    border-radius: 6px;
    font-weight: bold;
    padding: 2%;
    cursor: pointer;
}

.customerInformationSeparator {
    margin-top: 4%;
    margin-right: 7.5%;
    border-bottom: 1px solid #0930cb;
}

    // - - LOYALTY CARD - - //

.userLoyaltyCardLoading {
    padding-top: 23%;
}

.userLoyaltyCardConfirmationBtns {
    width: 100%;
    text-align: left;
    margin-left: 10%;
}

.userLoyaltyCardConfirmationBtns h4 {
    color: #0930cb;
    font-family: arvo;
}

.userLoyaltyCardConfirmationBtns button {
    width: 20%;
    margin-right: 5%;
    padding: 2%;
    border: 2px solid #0930cb;
    border-radius: 7.5px;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
}

.userLoyaltyCardYesConfirmBtn {
    background-color: #0930cb;
    color: white;
}

.userLoyaltyCardNoConfirmBtn {
    background-color: white;
    color: #0930cb;
}

.userLoyaltyConfirmationLoading {
    text-align: center;
    padding-top: 5%;
    margin-right: 11%;
}

.userLoyaltyCardSuccessMessage {
    margin-top: 3.5%;
    margin-left: 10%;
}

.userLoyaltyCardSuccessMessage h1 {
    font-size: 20px;
}

.userLoyaltyCardSuccessMessage img {
    width: 5% !important;
}

.userLoyaltyCardNoConnection img {
    margin-top: 21%;
    width: 12.5%;
}

.userPointsCard {
    width: 85%;
    background-color: white;
    height: 35%;
    margin-left: 1%;
    border-radius: 10px;
    border: 2px solid black;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    height: 32.5vh;
}

.userPointsCard h4 {
    margin-bottom: 0px;
    text-align: left;
    padding: 3%;
    padding-bottom: 1.5%;
    font-family: arvo;
    margin-top: 0px;
}

.userPointsCard h3 {
    margin-top: 0px;
    text-align: left;
    padding-left: 3%;
    padding-bottom: 2.5%;
    font-weight: bold;
    color: #0930CB;
    font-family: arvo;
    margin-bottom: 0px;
    
}

.userPointsCardInnerContainer {
    padding-bottom: 0%;
}

.userPointsCardInnerContainer:after {
    content: "";
    display: table;
    clear: both;
}

.userPointsCardIcon {
    text-align: center;
    width: 25%;
    float: left;
}

.userPointsCardDetails {
    text-align: left;
    width: 75%;
    float: left;
}

.userPointsCardIcon img {
    // width: 100%;
    height: 60px;
    height: 60px;
    border: 3.5px solid #0930CB;
    padding: 7%;
    border-radius: 50%;
    margin-bottom: 0px;
}   

.userPointsCardDetails h1 {
    margin-top: 0px;
    font-family: Arvo;
    font-weight: bold;
    margin-bottom: 0px;
}

.userPointsCardDetails p {
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    font-family: Arvo;
    font-weight: bold;
}

.userPointsCardFooter {
    margin-bottom: 0px;
}

.userPointsCardFooter:after {
    content: "";
    display: table;
    clear: both;
}

.userPointsCardLogo {
    text-align: left; 
    width: 50%;
    float: left;
}

.userPointsCareNumber {
    text-align: right; 
    width: 50%;
    float: left;
}

.userPointsCardLogo img {
    border-radius: 5px;
    width: 60%;
    margin-top: 0px;
    margin-left: 5%;
    height: 80%;
    margin-bottom: 3.5%;
}

.userPointsCardNumber p {
    font-size: 25px;
    margin-right: 6.5%;
    text-align: right;
    padding-bottom: 3%;
    margin-top: 1%;
    font-family: kanit;
}   

    // - - LOYALTY CARDS SETTING - - //

.loyaltyCardSettings {
    height: 100%;
    border-left: 1px solid #0930cb;
}

.loyaltyCardSettings h2 {
    margin-top: 0px;
    text-align: left;
    margin-left: 6.5%;
}

    // - SETTINGS SECTION - //

.settingSection {
    margin-left: 5%;
    margin-bottom: 1.5%;
}

.settingSection:after {
    content: "";
    clear: both;
    display: table;
}

.settingCheckmark {
    float: left;
    width: 15%;
    text-align: center;
}

.settingDescription {
    float: left;
    width: 85%;
    text-align: left;
}

.settingCheckmark img {
    width: 40%;
}

.settingCheckmark img:hover {
    width: 42%;
    cursor: pointer;
}

.settingDescription p {
    margin-top: 1.25%;
    font-family: gabarito;
    color: #0930cb;
    font-size: 18px;
    font-weight: bold;
}

    // - CARD COLOR PICKER - //

.cardColorPicker {
    text-align: left;
    margin-left: 10%;
}

.cardColorPicker h4 {
    margin-top: 0px;
    margin-bottom: 2%;
    text-align: left;
    color: #0930cb;
    font-family: arvo;
    font-size: 18px;
}

.cardColorPicker button {
    margin-top: 2%;
    width: 20%;
    padding: 1.5%;
    border: 2px solid #0930cb;
    background-color: #0930cb;
    color: white;
    font-family: arvo;
    font-weight: bold;
    border-radius: 8px;
    cursor: pointer;
}

    // - - INVITATION CARD - - //

.invitationCardLoading {
    padding-top: 17.5%;
}

.invitationCard {
    // margin-top: 3%;
    width: 90%;
    margin-left: 1%;
    background-color: white;
    border-radius: 8px;
    border: 1px solid black;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    margin-bottom: 4.5%;
    padding: 0.1%;
    height: 28vh;
}

.invitationCard h2 {
    text-align: center;
    font-family: Arvo;
    font-weight: bold;
    color: #0930CB;
    padding-top: 3.5%;
    margin-bottom: 0px;
}

.invitationCard p {
    text-align: justify;
    margin-left: 5%;
    margin-right: 5%;
    font-family: Arvo;
    // font-weight: bold;
}

.invitationCardBtn {
    text-align: center;
}

.invitationCard button {
    // margin: auto;
    margin-bottom: 5%;
    width: 70%;
    padding: 3.5%;
    border: 2px solid transparent;
    border-radius: 7px;
    background-color: #0930CB;
    color: white;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
    font-size: 15.5px;
}

.referralPolicyInformation {
    text-align: left;
    margin-left: 1%;
}

.referralPolicyInformation p {
    margin-bottom: 0px;
    margin-top: 0px;
    margin-left: 1%;
    font-family: arvo;
    text-decoration: underline;
    font-weight: bold;
    font-size: 20px;
}

.referralPolicyInformation h2 {
    margin-left: 1%;
    margin-top: 1%;
}

.referralCodeDetails {
    text-align: left;
    margin-left: 7.5%;
}

.referralCodeDetails h4 {
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-bottom: 1%;
}

.referralCodeDetails h5 {
    margin-top: 1.5%;
    margin-right: 15%;
    margin-bottom: 1%;
    font-family: gabarito;
    color: #0930cb;
    // width: 100%;
}

.referralCodeDetails input {
    font-size: 19.5px;
    padding: 1.5%;
    width: 73.5%;
    border: 1px solid black;
    outline: none;
    margin-bottom: 3.5%;
    font-family: gabarito;
}

.referralCodeDetails textarea {
    resize: none;
    outline: none;
    width: 80%;
    padding: 1%;
    font-size: 15px;
    height: 3.5em;
    font-family: gabarito;
}

.invitationCardConfirmationBtns {
    width: 100%;
    text-align: left;
    // margin-left: 5%;
    margin-top: 4%;
}

.invitationCardConfirmationBtns h4 {
    // all: unset;
    color: #0930cb;
    font-family: arvo;
    margin-bottom: 4%;
}

.invitationCardConfirmationBtns button {
    width: 20%;
    margin-right: 5%;
    padding: 2%;
    border: 2px solid #0930cb;
    border-radius: 7.5px;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
}

.invitationCardConfirmationLoading {
    text-align: center;
    padding-top: 5%;
    margin-right: 17.5%;
}

.invitationCardConfirmationSuccessMessage {
    margin-top: 3.5%;
    margin-left: 10%;
}

.invitationCardConfirmationSuccessMessage {
    margin-top: 3.5%;
    margin-left: 0%;
}

.invitationCardConfirmationSuccessMessage h1 {
    font-size: 20px;
}

.invitationCardConfirmationSuccessMessage img {
    width: 5% !important;
}

    // - - RECENT ACTIVITY - - //

.recentActivityCampaign {
    text-align: left;
    margin-left: 1%;
    font-weight: bold;
    font-family: arvo;
    margin-bottom: 5%;
}

.recentActivityCampaign h4 {
    // color: white;
    // margin-bottom: 1%;
}

        // - RECENT ACTIVITY CELL - //

.recentActivityCellCampaignLoading {
    margin-left: 0px;
    text-align: center;
    margin-right: 5%;
    padding-top: 7%;
}

.recentActivityCellCampaign {
    width: 85%;
    height: 11vh;
    padding-left: 5%;
    background-color: white;
    border-radius: 8px;
    margin-top: 0%;
    border: 1px solid black;
    padding-top: 2%;
    padding-right: 2%;
    padding-bottom: 2%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    margin-bottom: 5%;
}

.recentActivityCellCampaign:after {
    content: "";
    display: table;
    clear: both;
}

.recentActivityImgCampaign {
    text-align: center;
    width: 15%;
    float: left;
}

.recentActivityDetailsCampaign {
    text-align: left;
    width: 60%;
    float: left;
}

.recentActivityTimestampCampaign {
    text-align: center;
    width: 25%;
    float: left;
}

.recentActivityImgCampaign img {
    margin-top: 10.5%;
    margin-bottom: 5%;
    height: 55px;
    width: 55px;
    border-radius: 50%;
    border: 2.5px solid #0930cb;
    padding: 11.5%;
}

.recentActivityDetailsCampaign h5 {
    margin-left: 6.5%;
    margin-top: 4%;
    font-weight: bold;
    font-size: 15px;
    color: #228300;
    margin-bottom: 0px;
}

.recentActivityDetailsCampaign label {
    font-family: gabarito;
    color: #0930cb;
    margin-top: 0px;
    margin-left: 5%;
}

.recentActivityDetailsCampaign p {
    margin-left: 5.5%;
    margin-top: 2%;
    font-weight: bold;
    font-size: 15px;
    color: #000;
    margin-bottom: 1%;
}

.recentActivityTimestampCampaign h4 {
    // display: flex;
    // align-items: center;
    font-size: 22.5px;
    margin-top: 27.5%;
    font-family: arvo;
    color: #0930cb;
    font-weight: bold;
}


    // - - - - - - - - - - OFFER CARDS - - - - - - - - - -  - //

    // - - LATEST OFFER CARDS - - //

.latestOfferCards:after {
    content: "";
    display: table;
    clear: both;
}

.offerCard {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35), 0 6px 20px 0 rgba(0, 0, 0, 0.35);
    text-align: center;
    width: 27.5%;
    float: left;
    border-radius: 10px;
    margin-right: 5%;
    background-color: #321d05;
    height: 61.5vh;
    overflow: hidden;
}

.offerCard h2 {
    text-align: center;
    font-size: 30px;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    margin-bottom: 6%;
}

.offerCardLabel {
    width: 100%;
    background-color: #FF914D;
    padding-top: 5%;
    padding-bottom: 5%;
}

.offerCardLabel label {
    font-family: arvo;
    font-weight: bold;
    font-size: 18px;
}

.offerCardBtn button {
    margin-top: 5.5%;
    width: 45%;
    background-color: #ff;
    font-family: arvo;
    padding: 2%;
    color: #321d05;
    border: 2px solid transparent;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
}

.offerCard p {
    text-align: center;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    font-size: 15px;
}

.offerCard span {
    margin-right: 2%;
}

.offerCard h4 {
    margin-top: 5%;
    font-family: arvo;
    font-weight: bold;
    font-size: 20px;
    color: white;
    margin-bottom: 4%;
}

.offerCard img {
    max-width: 90%;
    height: auto;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

.offerCard h5 {
    margin-top: 0px;
    color: white;
}

    // - - OFFERCARD MORE INFO - - //

.offerCardMoreInfo {
    position: relative;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35), 0 6px 20px 0 rgba(0, 0, 0, 0.35);
    text-align: center;
    width: 27.5%;
    float: left;
    border-radius: 10px;
    margin-right: 5%;
    background-color: #fff;
    height: 56.5vh;
}

.offerCardMoreInfo h3 {
    text-align: left;
    margin-left: 3%;
    font-family: arvo;
    color: #321d05;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 1.5%;
}

.offerCardMoreInfo textarea {
    width: 92.5%;
    height: 36.5vh;
    resize: none;
    padding: 1.5%;
    outline: none;
    font-family: gabarito;
    font-size: 19px;
    border-bottom: 1px solid #321d05;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    border-top: 1px solid transparent;
}

.offerCardMoreInfo button {
    position: absolute;
    bottom: 5%; 
    right: 2.5%; 
    padding: 2%;
    width: 25%;
    background-color: #321d05;
    color: white;
    font-family: arvo;
    border: 2px solid #321d05;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
}

    // - - LOADING MORE CARD INFO - - //

.loadingMoreCardInfo {
    text-align: center;
    padding-top: 65%;
    // padding-bottom: 3%;
}

    // - - OFFERCARD AUTOSAVE - - //

.offerCardAutosave {
    text-align: right;
    // margin-right: 7.75%;
}

.offerCardAutosave p {
    margin-top: 10%;
    font-family: gabarito;
    // font-style: italic;
    font-weight: bold;
    color: #0930cb;
    font-family: 15px; 
}

    // - - OFFERCARD AUTOSAVE LOADING - - //

.loadingAutosave {
    padding-bottom: 0px;
    padding-right: 12%;
    margin-top: 1.5%;
}

    // - - OFFERCARD HEADER - - //

.offerCardHeader input {
    margin-top: 5%;
    width: 95%;
    margin-top: 6%;
    background-color: #321d05;
    text-align: center;
    font-size: 30px;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    margin-bottom: 6%;
    border: 1px solid transparent;
}

.offerCardHeader input:focus {
    outline: none;
}

    // - - OFFERCARD SUBHEADER - - //

.offerCardLabel input {
    width: 95%;
    // margin-top: 5%;
    text-align: center;
    font-family: arvo;
    font-weight: bold;
    font-size: 18px;
    color: black;
    border: 1px solid transparent;
    background-color: #FF914D;
}

.offerCardLabel input:focus {
    outline: none;
}

    // - - OFFERCARD PROMO MINI TEXT - - //

.offerCardLastPromoText input {
    width: 95%;
    background-color: #321d05;
    text-align: center;
    font-family: arvo;
    font-weight: bold;
    color: white;
    font-size: 15px;
    border: 1px solid transparent;
}

.offerCardLastPromoText input:focus {
    outline: none;
}

    // - - OFFERCARD UPLOAD IMAGE - - //

.offerCardImgDiv {
    height: 20vh;
    width: 100%;
}

.offerCardImgDiv h5 {
    font-family: rubik;
}

.offerCardUploadImage {
    text-align: right;
    margin-right: 5%;
    // margin-bottom: 7.5%;
}

.offerCardUploadImage button {
    background-color: white;
    margin-top: 5%;
    padding: 1%;
    font-size: 75%;
    border-radius: 5px;
    font-family: gabarito;
    border: 1px solid white;
    cursor: pointer;
    padding-left: 2%;
    padding-right: 2%;
}
    // - - OFFERCARDS IMAGE - - //

.loadingOfferCardImg {
    text-align: center;
    padding-top: 20%;
}

    // - - OFFERCARDS PUBLISH BUTTON - - //

.offerCardsBtns {
    margin-top: 1.5%;
    text-align: right;
    margin-right: 7.5%;
}

.offerCardsBtns button {
    background-color: #0930cb;
    color: white;
    font-family: arvo;
    padding: 1.25%;
    border-radius: 8px;
    border: 2px solid #0930cb;
    width: 20%;
    font-size: 85%;
    font-weight: bold;
    cursor: pointer;
//    margin-bottom: 7.5%;
}

    // - - PREVIEW OFFER CARDS - - //

.previewOfferCardsHeader {
    display: flex;
    justify-content: space-between;
}

.previewOfferCardsHeader h2 {
    margin-top: 0.5%;
    font-family: arvo;
    color: #0930cb;

}

.previewOfferCardsHeader button {
    width: 20%;
    margin-right: 7.5%;
    margin-top: 0px;
    margin-bottom: 1%;
    background-color: white;
    border: 2px solid #D40C0C;
    border-radius: 8px;
    color: #D40C0C;
    padding: 0.25%;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
    font-size: 80%;
}

.previewOfferCardsHeader button:hover {
    background-color: #D40C0C;
    color: white;
}

.previewOfferCards:after {
    content: "";
    display: table;
    clear: both;
}

.previewOfferCard {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35), 0 6px 20px 0 rgba(0, 0, 0, 0.35);
    text-align: center;
    width: 27.5%;
    float: left;
    border-radius: 10px;
    margin-right: 5%;
    background-color: #321d05;
    height: 55vh;
}

.previewOfferCard h2 {
    text-align: center;
    font-size: 27px;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    margin-bottom: 6%;
}

.previewOfferCard p {
    text-align: center;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    font-size: 15px;
}

.previewOfferCard span {
    margin-right: 2%;
}

.previewOfferCard h4 {
    margin-top: 5%;
    font-family: arvo;
    font-weight: bold;
    font-size: 20px;
    color: white;
    margin-bottom: 5.5%;
}

.previewOfferCard img {
    width: 100%;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

    // - - PREVIEW OFFER CARD MORE INFO - - //

.previewOfferCardMoreInfo {
    position: relative;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35), 0 6px 20px 0 rgba(0, 0, 0, 0.35);
    text-align: center;
    width: 27.5%;
    float: left;
    border-radius: 10px;
    margin-right: 5%;
    background-color: #fff;
    height: 55vh;
}

.previewOfferCardMoreInfo h3 {
    text-align: left;
    margin-left: 3%;
    font-family: arvo;
    color: #321d05;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 1.5%;
}

.previewOfferCardMoreInfo textarea {
    width: 92.5%;
    height: 36.5vh;
    resize: none;
    padding: 1.5%;
    outline: none;
    font-family: gabarito;
    font-size: 19px;
    border-bottom: 1px solid #321d05;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    border-top: 1px solid transparent;
    cursor: auto;
}

.previewOfferCardMoreInfo button {
    position: absolute;
    bottom: 5%; 
    right: 2.5%; 
    padding: 2%;
    width: 25%;
    background-color: #321d05;
    color: white;
    font-family: arvo;
    border: 2px solid #321d05;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
}

    // - - PREVIEW OFFER CARD LOADING - - //

.previewOfferCardLoading {
    text-align: center;
    padding-top: 65%;
}

    // - - OFFER CARD CONFIRMATION BUTTONS - - //

.offerCardConfirmationBtn h3 {
    margin-top: 2.5%;
    color: #0930cb;
    font-family: arvo;
    margin-bottom: 0.5%;
}

.offerCardConfirmationBtn button {
    margin-top: 0.35%;
    margin-right: 2.5%;
    padding: 1.25%;
    width: 12.5%;
    border-radius: 8px;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
    font-size: 15px;
    margin-bottom: 0.5%;
}

.offerCardConfirmationNoBtn {
    background-color: white;
    color: #0930cb;
    border: 2px solid #0930cb;
}

.offerCardConfirmationYesBtn {
    background-color: #0930cb;
    color: white;
    border: 2px solid #0930cb;
}

    // - - FINAL PUBLISH BUTTONS LOADING - - //

.loadingFinalPublishBtns {
    // text-align: center;
    padding-top: 1%;
    margin-left: 17.5%;
}

    // - - PUBLISH SUCCESS MESSAGE - - //

.publishSuccessMessage {
    display: flex;
    align-items: center; 
}

.publishSuccessMessage h1 {
    // all: unset;
    margin-top: 0px !important;
    font-family: gabarito !important;
    // font-size: 18.5px;
    color: #8A8A8A !important;
}

.publishSuccessMessage label {
    color: black;
}

.publishSuccessMessage img {
    // margin-top: 0px;
    width: 3%;
    margin-left: 1%;
}

    // - - OFFER CARDS FULL PAGE LOADING - - //

.offerCardsPageLoading {
    text-align: center;
    padding-top: 19.5%;
    margni-right: 10.5%;
}



`

export default class Campaigns extends Component {
    constructor(props) {
        super(props)
        this.typingTimer = null;
        this.state = {

                //* - - CAMPAIGN PAGE OPTIONS - - *//

            showCampaignPageOptions: true,
            showCampaignsPageLoading: false,
            campaignInnerLevel: false,

                //* - - CUSTOMER INFORMATION - - *//

            showCustomerInformation: false,
            showUserLoyaltyCard: false,
            showUserLoyaltyCardLoading: false,
            showUserLoyaltyCardPublishBtn: false,
            showUserLoyaltyCardConfirmationBtns: false,
            showUserLoyaltyConfirmationLoading: false,
            showUserLoyaltySuccessMessage: false,
            showUserLoyaltyNoSuccessMessage: false,
            showInvitationCard: false,
            showInvitationCardLoading: false,
            showInvitationCardPublishBtn: false,
            showInvitationCardConfirmationBtns: false,
            showInvitationCardConfirmationLoading: false,
            showInvitationCardSuccessMessage: false,
            showRecentActivityCard: true,
            showRecentActivityCardLoading: false,
            showCardSetting1Unchecked: false,
            showCardSetting2Unchecked: false,
            showCardSetting1Checked: false,
            showCardSetting2Checked: false,
            showCardPointsTillReward: true,
            showCardUserNumber: true,
            showReferralErrorMsg1: true,
            showReferralErrorMsg2: true,
            showReferralErrorMsg3: true,
            cardBackgroundColor: "#FFFFFF",
            userLoyaltyLastPublishedTime: "",
            referralTitleBorderSize: '1',
            referralTitleBorderColor: "black",
            referralTextBorderSize: '1',
            referralTextBorderColor: "black",
            invitationCardLastPublishedTime: "",
            invitationCardHeader: "",
            invitationCardText: "",
            referralPolicyPoints: "",
            referralPolicyReferralCount: "",
            recentActivityTimestamp: "",

                //* - - OFFER CARDS - - *//

            showPreviewOfferCards: false,
            showOfferCardsPageLoading: false,
            showPreviewCard1: true,
            showPreviewCard2: true,
            showPreviewCard3: true,
            showPreviewCard1MoreInfo: false,
            showPreviewCard2MoreInfo: false,
            showPreviewCard3MoreInfo: false,
            showOfferCards: false,
            showOfferCardsSubheader: false,
            showOfferCard1: true,
            showOfferCard2: true,
            showOfferCard3: true,
            showOfferCard1Img: true,
            showOfferCard1ImgLoading: false,
            showOfferCard1MoreInfo: false,
            showOfferCard1MoreInfoLoading: false,
            showOfferCard1DisplayLoading: false,
            showOfferCard2Img: true,
            showOfferCard2ImgLoading: false,
            showOfferCard2MoreInfo: false,
            showOfferCard2MoreInfoLoading: false,
            showOfferCard2DisplayLoading: false,
            showOfferCard3Img: true,
            showOfferCard3ImgLoading: false,
            showOfferCard3MoreInfo: false,
            showOfferCard3MoreInfoLoading: false,
            showOfferCard3DisplayLoading: false,
            showPublishBtn: false,
            showPublishRealBtn: true,
            showPublishLoadingBtn: false,
            confirmPublishBtnText: "Are you sure you are ready to publish?",
            showConfirmPublishBtns: false,
            showFinalConfirmPublishBtns: true,
            showLoadingConfirmationPublishBtns: false,
            showPublishSuccessMessage: false,
            firstPromoText: "",
            firstPromoSubtext: "",
            firstPromoMiniText: "",
            firstPromoImg: "",
            firstPromoMoreInfoText: "",
            secondPromoText: "",
            secondPromoSubtext: "",
            secondPromoMiniText: "",
            secondPromoImg: "",
            secondPromoMoreInfoText: "",
            thirdPromoText: "",
            thirdPromoSubtext: "",
            thirdPromoMiniText: "",
            thirdPromoImg: "",
            thirdPromoMoreInfoText: "",
            offerCardAutosaveLatestTime: "",
            lastPublishedTime: "",
            lastPublishedDisplay: ""
        }
        this.childCampaignRef = React.createRef();
    }

    componentDidMount = () => {
        this.loadOfferCardsData()
        this.loadCustomerInformation()
        //* - RECENT ACTIVITY TIMESTAMP - *//
        this.getTimestampActivity()
    }

        //* - - - - - - - - - - - - - - - *//
        //*     CAMPAIGN PAGE OPTIONS     *//
        //* - - - - - - - - - - - - - - - *//


    renderSelectedCampaignOptions = () => {

        let selectedCampaignOption

        let selectedOptionChild1

        let selectedOptionChild2

        let selectedOptionChild3

        return(
            <div className='campaignSelectedOptionsCarrot'>
                <h4>{selectedCampaignOption}<label>{selectedOptionChild1}</label><label>{selectedOptionChild2}</label><label>{selectedOptionChild3}</label></h4>
            </div> 
        )
    }

    challengeBox1Clicked  = () => {
        this.props.onChildChange(true)
        this.setState({
            showCampaignPageOptions: false,
            showCampaignsPageLoading: true
        })
        setTimeout(() => {
            this.setState({
                showCampaignsPageLoading: false,
                showCustomerInformation: true
            })
            // this.loadCustomerInformation()
            this.loadUserCardInformation()
        }, 2000);
    }

    challengeBox2Clicked  = () => {
        this.props.onChildChange(true)
        this.setState({
            showCampaignPageOptions: false,
            showCampaignsPageLoading: true
        })
        setTimeout(() => {
            this.setState({
                showCampaignsPageLoading: false,
                showOfferCards: true,
                showOfferCard1: true,
                showOfferCard2: true,
                showOfferCard3: true,
                showOfferCardsSubheader: true,
                showPublishBtn: true
            })
        }, 2000);
    }

    notifyParentComponent = () => {
        
    }

    moveBackToHome = () => {
        this.props.onChildChange(false)
        this.setState({
            showCustomerInformation: false,
            showOfferCards: false,
            showOfferCardsSubheader: false,
            showPublishBtn: false,
            showPreviewOfferCards: false,
            showConfirmPublishBtns: false,
            showOfferCardAutosaveUnsaved: false,
            showCampaignsPageLoading: true,
        })
        setTimeout(() => {
            this.setState({
                showCampaignsPageLoading: false,
                showCampaignPageOptions: true
            })
        }, 2000);
    }


        //* - - - - - - - - - - - - - - - *//
        //*  CUSTOMER INFORMATION OPTIONS *//
        //* - - - - - - - - - - - - - - - *//

    // loadUserInvitationCardI

    loadCustomerInformation = () => {

            //? - - GETTING CARD INFORMATION - - ?//
        // this.loadUserCardInformation()

            //? - - GETTING REFERRAL INVITATION INFORMATION - - ?//
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("leftSidePane")
        .doc("customerInformation")
        .collection("referralInformation")
        .doc("text")
        .get().then(doc => {
            if (doc.data().latestUpdated != "") {
                this.setState({
                    showInvitationCardConfirmationLoading: true,
                    invitationCardLastPublishedTime: doc.data().latestUpdated
                })
                setTimeout(() => {
                    this.setState({
                        showInvitationCardConfirmationLoading: false,
                        showInvitationCardSuccessMessage: true,
                        showInvitationCardPublishBtn: true
                    })
                }, 2000);
            } else {
                this.setState({
                    showInvitationCardPublishBtn: true
                })
            }
            if (doc.exists) {
                this.setState({
                    showInvitationCardLoading: true,
                    invitationCardHeader: doc.data().invitationCardHeader,
                    invitationCardText: doc.data().invitationCardText,
                    referralPolicyPoints: doc.data().referralPolicyPoints,
                    referralPolicyReferralCount: doc.data().referralPolicyReferralCount,
                })
                setTimeout(() => {
                    this.setState({
                        showInvitationCardLoading: false,
                        showInvitationCard: true
                    })
                }, 2000);
            }
        })

            //? - - GETTING RECENT ACTIVITY INFORMATION - - ?//
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("leftSidePane")
        .doc("customerInformation")
        .collection("recentActivityInformation")
        .doc("design")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    recentActivityLogo: doc.data().starLogo
                })
            }
        })
    }

    loadUserCardInformation = () => {
        let showPointsRemainingChecked = null
        let showUserCardNumberChecked = null
        let loyaltyCardView = null
        try {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("leftSidePane")
            .doc("customerInformation")
            .collection("cardInformation")
            .doc("design")
            .get().then(doc => {
                if (doc.exists) {
                    if (doc.data().showPointsRemaining == true) {
                        showPointsRemainingChecked = true
                        this.setState({
                            showCardSetting1Checked: true,
                            showCardSetting1Unchecked: false,
                            showCardPointsTillReward: true
                        })
                    } else {
                        showPointsRemainingChecked = false
                        this.setState({
                            showCardSetting1Checked: false,
                            showCardSetting1Unchecked: true,
                            showCardPointsTillReward: false
                        })
                    }
                    if (doc.data().showUserCardNumber == true) {
                        showUserCardNumberChecked = true
                        this.setState({
                            showCardSetting2Checked: true,
                            showCardSetting2Unchecked: false,
                            showCardUserNumber: true
                        })
                    } else {
                        showUserCardNumberChecked = false
                        this.setState({
                            showCardSetting2Checked: false,
                            showCardSetting2Unchecked: true,
                            showCardUserNumber: false
                        })
                    }
    
                    if (doc.data().lastUpdated != "") {
                        this.setState({
                            showUserLoyaltyConfirmationLoading: true,
                            userLoyaltyLastPublishedTime: doc.data().latestUpdated
                        })
                        setTimeout(() => {
                            this.setState({
                                showUserLoyaltyConfirmationLoading: false,
                                showUserLoyaltySuccessMessage: true
                            })
                        }, 2000);
                    }
                    this.setState({
                        showUserLoyaltyCard: false,
                        showUserLoyaltyCardLoading: true,
                        cardBackgroundColor: doc.data().backgroundColor,
                        cardPointsLogo: doc.data().pointsLogo,
                        cardCompanyLogo: doc.data().companyLogo
                    })
                    loyaltyCardView = true
                    setTimeout(() => {
                        this.setState({
                            showUserLoyaltyCardLoading: false,
                            showUserLoyaltyCardPublishBtn: true,
                            showUserLoyaltyCard: true
                        })
                    }, 2000);
                }
            })
            .catch((error) => {
                if (error) {
                    this.setState({
                        showUserLoyaltyCardNoConnection: true,
                        showCardSetting1Unchecked: true,
                        showCardSetting2Unchecked: true
                    })
                }
            })
        } catch (error) {
            
        } finally {
            
        }
        
    }

    //* - CARD INFORMATION - *//

    cardSetting1UncheckedClicked = () => {
        this.setState({
            showCardSetting1Unchecked: false,
            showCardPointsTillReward: true,
            showCardSetting1Checked: true
        })
    }

    cardSetting2UncheckedClicked = () => {
        this.setState({
            showCardSetting2Unchecked: false,
            showCardUserNumber: true,
            showCardSetting2Checked: true
        })
    }

    cardSetting1CheckedClicked = () => {
        this.setState({
            showCardSetting1Unchecked: true,
            showCardPointsTillReward: false,
            showCardSetting1Checked: false
        })
    }

    cardSetting2CheckedClicked = () => {
        this.setState({
            showCardSetting2Unchecked: true,
            showCardUserNumber: false,
            showCardSetting2Checked: false
        })
    }


    handleCardColorChange = (color) => {
        this.setState({
            cardBackgroundColor: color.hex
        })
    }

    resetColorPickerClicked = () => {
        this.setState({
            cardBackgroundColor: "#FFFFFF"
        })
    }

    handleReferralChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }

    getTimestampActivity = () => {
        // Create a new Date object with the current date and time
        const currentDate = new Date();

        // Format the date to "dd/mm/yy" and the time to "hh:mm"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format (no AM/PM)
        });

        const formattedDateTime = dateFormatter.format(currentDate);

        this.setState({
            recentActivityTimestamp: formattedDateTime
        })
    }


    userLoyaltyPublishBtnClicked = () => {
        this.setState({
            showUserLoyaltyCardPublishBtn: false,
            showUserLoyaltyConfirmationLoading: true,
            showUserLoyaltySuccessMessage: false,
            showUserLoyaltyNoSuccessMessage: false
          });
          setTimeout(() => {
            this.setState({
                showUserLoyaltyConfirmationLoading: false,
                showUserLoyaltyCardConfirmationBtns: true,
            });
        }, 2500); 
    }
    
    userLoyaltyNoConfirmationClicked = () => {
        this.setState({
            showUserLoyaltyCardConfirmationBtns: false,
            showUserLoyaltyConfirmationLoading: true
          });
          setTimeout(() => {
            if (this.state.userLoyaltyLastPublishedTime !== "") {
                this.setState({
                    showUserLoyaltySuccessMessage: true
                })
            }
            this.setState({
                showUserLoyaltyConfirmationLoading: false,
                showUserLoyaltyCardPublishBtn: true,
            });
        }, 2500); 
    }

    userLoyaltyYesConfirmationClicked = async () => {
        const currentDate = new Date();

        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });

        const formattedDateTime = dateFormatter.format(currentDate);

        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';

        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;

        this.setState({
            showUserLoyaltyCardConfirmationBtns: false,
            showUserLoyaltyCard: false,
            showUserLoyaltyConfirmationLoading: true,
            showUserLoyaltyCardLoading: true
        });

        let showPointsRemaining
        let showLoyaltyCardNumber 

        if (this.state.showCardSetting1Checked == true) {
            showPointsRemaining = true
        } else {
            showPointsRemaining = false
        }

        if (this.state.showCardSetting2Checked == true) {
            showLoyaltyCardNumber = true
        } else {
            showLoyaltyCardNumber = false
        }
          
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("leftSidePane")
        .doc("customerInformation")
        .collection("cardInformation")
        .doc("design")
        .update({
            showPointsRemaining: showPointsRemaining,
            showUserCardNumber: showLoyaltyCardNumber,
            backgroundColor: this.state.cardBackgroundColor,
            latestUpdated: formattedDateTimeWithAmPm
        })
        .then(async () => {
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("campaigns")
            .collection("leftSidePane")
            .doc("customerInformation")
            .collection("cardInformation")
            .doc("design")
            .update({
                showPointsRemaining: showPointsRemaining,
                showUserCardNumber: showLoyaltyCardNumber,
                backgroundColor: this.state.cardBackgroundColor,
                latestUpdated: formattedDateTimeWithAmPm
            })
            setTimeout(() => {
                this.setState({
                    showUserLoyaltyConfirmationLoading: false,
                    showUserLoyaltyCardLoading: false,
                    showUserLoyaltyCard: true,
                    showUserLoyaltyCardPublishBtn: true,
                    showUserLoyaltySuccessMessage: true,
                    userLoyaltyLastPublishedTime: formattedDateTimeWithAmPm
                });
            }, 2500); 
            // this.loadCustomerInformation()
            this.loadUserCardInformation()
        })
        .catch((error) => {
            setTimeout(() => {
                this.setState({
                    showUserLoyaltyConfirmationLoading: false,
                    showUserLoyaltyCardLoading: false,
                    showUserLoyaltyCard: true,
                    showUserLoyaltyCardPublishBtn: true,
                    showUserLoyaltyNoSuccessMessage: true,
                    userLoyaltyLastPublishedTime: formattedDateTime
                });
            }, 2500); 
            this.loadCustomerInformation()
        })
    }

    //* - INVITATION CARD - *//

    invitationCardPublishBtnClicked = () => {
        if (this.state.invitationCardHeader == "") {
            this.setState({
                referralTitleBorderColor: "red",
                referralTitleBorderSize: "2"
            })
        } else {
            this.setState({
                referralTitleBorderSize: "1",
                referralTitleBorderColor: "black"
            })
        }

        if (this.state.invitationCardText == "") {
            this.setState({
                referralTextBorderColor: "red",
                referralTextBorderSize: "2"
            })
        } else {
            this.setState({
                referralTextBorderSize: "1",
                referralTextBorderColor: "black"
            })
        }

        if ((!this.state.invitationCardText.includes(`${this.state.referralPolicyPoints} points`) || !this.state.invitationCardText.includes(`${this.state.referralPolicyPoints}points`))) {
            this.setState({
                referralTextBorderColor: "red",
                referralTextBorderSize: "2"
            })
        } else {
            this.setState({
                referralTextBorderSize: "1",
                referralTextBorderColor: "black"
            })
        }

        if (this.state.invitationCardHeader != "" && this.state.invitationCardText != "" && (this.state.invitationCardText.includes(`${this.state.referralPolicyPoints} points`) || this.state.invitationCardText.includes(`${this.state.invitationCardText.includes(`${this.state.referralPolicyPoints}points`)}`))) {
            this.setState({
                referralTitleBorderSize: "1",
                referralTitleBorderColor: "black",
                referralTextBorderSize: "1",
                referralTextBorderColor: "black",
                showInvitationCardPublishBtn: false,
                showInvitationCardConfirmationLoading: true,
                showInvitationCardSuccessMessage: false,
                showInvitationCardNoSuccessMessage: false
              });
              setTimeout(() => {
                this.setState({
                    showInvitationCardConfirmationLoading: false,
                    showInvitationCardConfirmationBtns: true,
                });
            }, 2500); 
        }
    }

    invitationCardNoConfirmationClicked = () => {
        this.setState({
            showInvitationCardConfirmationBtns: false,
            showInvitationCardConfirmationLoading: true
          });
          setTimeout(() => {
            if (this.state.invitationCardLastPublishedTime !== "") {
                this.setState({
                    showInvitationCardSuccessMessage: true
                })
            }
            this.setState({
                showInvitationCardConfirmationLoading: false,
                showInvitationCardPublishBtn: true,
            });
        }, 2500); 
    }

    invitationCardYesConfirmationClicked = async () => {
        const currentDate = new Date();

        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });

        const formattedDateTime = dateFormatter.format(currentDate);

        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';

        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;

        this.setState({
            showInvitationCard: false,
            showInvitationCardConfirmationBtns: false,
            showInvitationCardConfirmationLoading: true
        });

        if (this.state.invitationCardHeader != "" && this.state.invitationCardText != "" && (this.state.invitationCardText.includes(`${this.state.referralPolicyPoints} points`) || this.state.invitationCardText.includes(`${this.state.invitationCardText.includes(`${this.state.referralPolicyPoints}points`)}`))) {
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("leftSidePane")
            .doc("customerInformation")
            .collection("referralInformation")
            .doc("text")
            .update({
                invitationCardHeader: this.state.invitationCardHeader,
                invitationCardText: this.state.invitationCardText,
                latestUpdated: formattedDateTimeWithAmPm
            })
            .then(async() => {
                await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("members")
                .doc("campaigns")
                .collection("leftSidePane")
                .doc("customerInformation")
                .collection("referralInformation")
                .doc("text")
                .update({
                    invitationCardHeader: this.state.invitationCardHeader,
                    invitationCardText: this.state.invitationCardText,
                    latestUpdated: formattedDateTimeWithAmPm
                })
                setTimeout(() => {
                    this.setState({
                        showInvitationCardConfirmationLoading: false,
                        showInvitationCardPublishBtn: true,
                        showInvitationCardSuccessMessage: true,
                        invitationCardLastPublishedTime: formattedDateTimeWithAmPm
                    });
                }, 2500); 
                this.loadCustomerInformation()
            })
            .catch((error) => {
                //! - - SHOW ERROR HANDLING MESSAGE HERE - - !//
            })
        }
    }


        //* - - - - - - - - - - - - - - - *//
        //*       OFFER CARD OPTIONS      *//
        //* - - - - - - - - - - - - - - - *//


    loadOfferCardsData = () => {

            //* - - LAST UPDATE TIME - - *//

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    lastPublishedDisplay: doc.data().lastPublished
                })
            }
        })

            //* - - OFFER CARD 1 - - *//

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard1")
        .doc("editingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    firstPromoText: doc.data().promoHeader,
                    firstPromoSubtext: doc.data().promoSubheader,
                    firstPromoMiniText: doc.data().promoMiniText,
                    firstPromoMoreInfoText: doc.data().promoMoreInfo,
                    firstPromoImg: doc.data().promoImg
                })
            }
        })

            //* - - OFFER CARD 2 - - *//

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard2")
        .doc("editingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    secondPromoText: doc.data().promoHeader,
                    secondPromoSubtext: doc.data().promoSubheader,
                    secondPromoMiniText: doc.data().promoMiniText,
                    secondPromoMoreInfoText: doc.data().promoMoreInfo,
                    secondPromoImg: doc.data().promoImg
                })
            }
        })

            //* - - OFFER CARD 3 - - *//

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard3")
        .doc("editingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    thirdPromoText: doc.data().promoHeader,
                    thirdPromoSubtext: doc.data().promoSubheader,
                    thirdPromoMiniText: doc.data().promoMiniText,
                    thirdPromoMoreInfoText: doc.data().promoMoreInfo,
                    thirdPromoImg: doc.data().promoImg
                })
            }
        })
    }

    handleChange = (event) => {
        const { id, value } = event.target;
    
        this.setState({ [id]: value });
    
        clearTimeout(this.typingTimer);
    
        this.typingTimer = setTimeout(() => {
          this.saveChanges(id);
        }, 2000);
    }

    saveChanges = (fieldId) => {
        console.log(fieldId)
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const formattedHours = hours < 10 ? `0${hours}` : hours;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const currentTime = `${formattedHours}:${formattedMinutes}`;
    
        this.setState({
          showOfferCardAutosaveUnsaved: true,
          showChangesDetectedLabel: false,
          showPublishRealBtn: false,
          showPublishLoadingBtn: true,
          showChangesDetectedLoading: true,
          offerCardAutosaveLatestTime: currentTime
        });
    
        // You can perform your save operation here, e.g., an API request to save data.
        this.saveEditingDataCard1(fieldId)
        this.saveEditingDataCard2(fieldId)
        this.saveEditingDataCard3(fieldId)
    
        // Once the data is saved, you can update the UI to indicate the changes were saved.
        setTimeout(() => {
            this.getSavedEditingDataCard1(fieldId)
            this.getSavedEditingDataCard2(fieldId)
            this.getSavedEditingDataCard3(fieldId)
            this.setState({
                showChangesDetectedLoading: false,
                showPublishLoadingBtn: false,
                showPublishRealBtn: true,
                showChangesDetectedLabel: true,
            });
        }, 1000); // Adjust the timing as needed
    }


    saveEditingDataCard1 = (id) => {
        if (id == "firstPromoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .update({
                promoHeader: this.state.firstPromoText,
            })
        } else if (id == "firstPromoSubtext") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .update({
                promoSubheader: this.state.firstPromoSubtext,
            })
        } else if (id == "firstPromoMiniText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .update({
                promoMiniText: this.state.firstPromoMiniText,
            })
        } else if (id == "firstPromoMoreInfoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .update({
                promoMoreInfo: this.state.firstPromoMoreInfoText
            })
        }
    }

    saveEditingDataCard2 = (id) => {
        if (id == "secondPromoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .update({
                promoHeader: this.state.secondPromoText,
            })
        } else if (id == "secondPromoSubtext") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .update({
                promoSubheader: this.state.secondPromoSubtext,
            })
        } else if (id == "secondPromoMiniText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .update({
                promoMiniText: this.state.secondPromoMiniText,
            })
        } else if (id == "secondPromoMoreInfoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .update({
                promoMoreInfo: this.state.secondPromoMoreInfoText
            })
        }
    }

    saveEditingDataCard3 = (id) => {
        if (id == "thirdPromoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .update({
                promoHeader: this.state.thirdPromoText,
            })
        } else if (id == "thirdPromoSubtext") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .update({
                promoSubheader: this.state.thirdPromoSubtext,
            })
        } else if (id == "thirdPromoMiniText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .update({
                promoMiniText: this.state.thirdPromoMiniText,
            })
        } else if (id == "thirdPromoMoreInfoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .update({
                promoMoreInfo: this.state.thirdPromoMoreInfoText
            })
        }
    }


    getSavedEditingDataCard1 = (id) => {
        if (id == "firstPromoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        firstPromoText: doc.data().promoHeader
                    })
                }
        })
        } else if (id == "firstPromoSubtext") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        firstPromoSubtext: doc.data().promoSubheader,
                    })
                }
            })
        } else if (id == "firstPromoMiniText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        firstPromoMiniText: doc.data().promoMiniText,
                    })
                }
            })
        } else if (id == "firstPromoMoreInfoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard1")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        firstPromoMoreInfoText: doc.data().promoMoreInfo
                    })
                }
            })
        }
    }

    getSavedEditingDataCard2 = (id) => {
        if (id == "secondPromoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        secondPromoText: doc.data().promoHeader
                    })
                }
        })
        } else if (id == "secondPromoSubtext") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        secondPromoSubtext: doc.data().promoSubheader,
                    })
                }
            })
        } else if (id == "secondPromoMiniText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        secondPromoMiniText: doc.data().promoMiniText,
                    })
                }
            })
        } else if (id == "secondPromoMoreInfoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard2")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        secondPromoMoreInfoText: doc.data().promoMoreInfo
                    })
                }
            })
        }
    }

    getSavedEditingDataCard3 = (id) => {
        if (id == "thirdPromoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        thirdPromoText: doc.data().promoHeader
                    })
                }
        })
        } else if (id == "thirdPromoSubtext") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        thirdPromoSubtext: doc.data().promoSubheader,
                    })
                }
            })
        } else if (id == "thirdPromoMiniText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        thirdPromoMiniText: doc.data().promoMiniText,
                    })
                }
            })
        } else if (id == "thirdPromoMoreInfoText") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("homePage")
            .doc("offerCards")
            .collection("offerCard3")
            .doc("editingData")
            .get().then(doc => {
                if(doc.exists) {
                    this.setState({
                        thirdPromoMoreInfoText: doc.data().promoMoreInfo
                    })
                }
            })
        }
    }


    moreInfoCard1Clicked = () => {
        this.setState({
            showOfferCard1: false,
            showOfferCard1MoreInfoLoading: true
          });
          setTimeout(() => {
            this.setState({
                showOfferCard1MoreInfoLoading: false,
                showOfferCard1MoreInfo: true
            });
        }, 2500); 
    }

    moreInfoCard2Clicked = () => {
        this.setState({
            showOfferCard2: false,
            showOfferCard2MoreInfoLoading: true
          });
          setTimeout(() => {
            this.setState({
                showOfferCard2MoreInfoLoading: false,
                showOfferCard2MoreInfo: true
            });
          }, 2500); 
    }

    moreInfoCard3Clicked = () => {
        this.setState({
            showOfferCard3: false,
            showOfferCard3MoreInfoLoading: true
          });
          setTimeout(() => {
            this.setState({
                showOfferCard3MoreInfoLoading: false,
                showOfferCard3MoreInfo: true
            });
          }, 2500); 
    }


    closeMoreInfoCard1Clicked = () => {
        this.setState({
            showOfferCard1MoreInfo: false,
            showOfferCard1MoreInfoLoading: true
        });
            setTimeout(() => {
            this.setState({
                showOfferCard1MoreInfoLoading: false,
                showOfferCard1: true
            });
        }, 2500); 
    }

    closeMoreInfoCard2Clicked = () => {
        this.setState({
            showOfferCard2MoreInfo: false,
            showOfferCard2MoreInfoLoading: true
        });
            setTimeout(() => {
            this.setState({
                showOfferCard2MoreInfoLoading: false,
                showOfferCard2: true
            });
        }, 2500); 
    }

    closeMoreInfoCard3Clicked = () => {
        this.setState({
            showOfferCard3MoreInfo: false,
            showOfferCard3MoreInfoLoading: true
        });
            setTimeout(() => {
            this.setState({
                showOfferCard3MoreInfoLoading: false,
                showOfferCard3: true
            });
        }, 2500); 
    }


    handleImageUploadOfferCard1 = (file) => {
        const storage = fire.storage();
        const storageRef = storage.ref();
        const imageRef = storageRef.child('clients/artcaffe/admin/campaigns/offerCards/offerCard1/offerCard1Img.jpg');
        const uploadTask = imageRef.put(file);
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            // Track the upload progress here
          },
          (error) => {
            // Handle any errors
          },
          () => {
            // The upload is complete, you can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              console.log('File available at', downloadURL);
              fire.firestore().collection("clients")
              .doc("artcaffe")
              .collection("admin")
              .doc("campaigns")
              .collection("homePage")
              .doc("offerCards")
              .collection("offerCard1")
              .doc("editingData")
              .update({
                promoImg: downloadURL
              })
            });
          }
        );
        this.setState({
            showOfferCard1Img: false,
            showOfferCard1ImgLoading: true
        });
            setTimeout(() => {
            this.getOfferCard1Img()
            this.setState({
                showOfferCard1ImgLoading: false,
                showOfferCard1Img: true
            });
        }, 2500); 
    };

    handleImageUploadOfferCard2 = (file) => {
        if (file != "") {
            const storage = fire.storage();
            const storageRef = storage.ref();
            const imageRef = storageRef.child('clients/artcaffe/admin/campaigns/offerCards/offerCard2/offerCard2Img.jpg');
            const uploadTask = imageRef.put(file);
            uploadTask.on(
            'state_changed',
            (snapshot) => {
                // Track the upload progress here
            },
            (error) => {
                // Handle any errors
            },
            () => {
                // The upload is complete, you can get the download URL
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL);
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("campaigns")
                .collection("homePage")
                .doc("offerCards")
                .collection("offerCard2")
                .doc("editingData")
                .update({
                    promoImg: downloadURL
                })
                });
            }
            );
            this.setState({
                showOfferCard2Img: false,
                showOfferCard2ImgLoading: true
            });
                setTimeout(() => {
                this.getOfferCard2Img()
                this.setState({
                    showOfferCard2ImgLoading: false,
                    showOfferCard2Img: true
                });
            }, 2500); 
        }
    };

    handleImageUploadOfferCard3 = (file) => {
        const storage = fire.storage();
        const storageRef = storage.ref();
        const imageRef = storageRef.child('clients/artcaffe/admin/campaigns/offerCards/offerCard3/offerCard3Img.jpg');
        const uploadTask = imageRef.put(file);
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            // Track the upload progress here
          },
          (error) => {
            // Handle any errors
          },
          () => {
            // The upload is complete, you can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              console.log('File available at', downloadURL);
              fire.firestore().collection("clients")
              .doc("artcaffe")
              .collection("admin")
              .doc("campaigns")
              .collection("homePage")
              .doc("offerCards")
              .collection("offerCard3")
              .doc("editingData")
              .update({
                promoImg: downloadURL
              })
            });
          }
        );
        this.setState({
            showOfferCard3Img: false,
            showOfferCard3ImgLoading: true
        });
            setTimeout(() => {
            this.getOfferCard3Img()
            this.setState({
                showOfferCard3ImgLoading: false,
                showOfferCard3Img: true
            });
        }, 2500); 
    };


    getOfferCard1Img = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard1")
        .doc("editingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    firstPromoImg: doc.data().promoImg
                })
            }
        })
    }

    getOfferCard2Img = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard2")
        .doc("editingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    secondPromoImg: doc.data().promoImg
                })
            }
        })
    }

    getOfferCard3Img = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard3")
        .doc("editingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    thirdPromoImg: doc.data().promoImg
                })
            }
        })
    }

    
    handleFileInputCard1 = () => {
        // Trigger the hidden file input field
        this.fileInput1.click();
    };

    handleFileInputCard2 = () => {
        // Trigger the hidden file input field
        this.fileInput2.click();
    };

    handleFileInputCard3 = () => {
        // Trigger the hidden file input field
        this.fileInput3.click();
    };


    previewMoreInfoCard1Clicked = () => {
        this.setState({
            showPreviewCard1: false,
            showPreviewCard1Loading: true
          });
          setTimeout(() => {
            this.setState({
                showPreviewCard1Loading: false,
                showPreviewCard1MoreInfo: true
            });
        }, 2500); 
    }

    previewMoreInfoCard2Clicked = () => {
        this.setState({
            showPreviewCard2: false,
            showPreviewCard2Loading: true
          });
          setTimeout(() => {
            this.setState({
                showPreviewCard2Loading: false,
                showPreviewCard2MoreInfo: true
            });
        }, 2500); 
    }

    previewMoreInfoCard3Clicked = () => {
        this.setState({
            showPreviewCard3: false,
            showPreviewCard3Loading: true
          });
          setTimeout(() => {
            this.setState({
                showPreviewCard3Loading: false,
                showPreviewCard3MoreInfo: true
            });
        }, 2500); 
    }


    closePreviewMoreInfoCard1Clicked = () => {
        this.setState({
            showPreviewCard1MoreInfo: false,
            showPreviewCard1Loading: true
          });
          setTimeout(() => {
            this.setState({
                showPreviewCard1Loading: false,
                showPreviewCard1: true
            });
        }, 2500); 
    }

    closePreviewMoreInfoCard2Clicked = () => {
        this.setState({
            showPreviewCard2MoreInfo: false,
            showPreviewCard2Loading: true
          });
          setTimeout(() => {
            this.setState({
                showPreviewCard2Loading: false,
                showPreviewCard2: true
            });
        }, 2500);
    }

    closePreviewMoreInfoCard3Clicked = () => {
        this.setState({
            showPreviewCard3MoreInfo: false,
            showPreviewCard3Loading: true,
          });
          setTimeout(() => {
            this.setState({
                showPreviewCard3Loading: false,
                showPreviewCard3: true
            });
        }, 2500);
    }

    confirmYesPublishClicked = async () => {
        const currentDate = new Date();

        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });

        const formattedDateTime = dateFormatter.format(currentDate);

        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';

        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;


        let offerCard1Published = false
        let offerCard2Published = false
        let offerCard3Published = false

        this.setState({
            showFinalConfirmPublishBtns: false,
            confirmPublishBtnText: "Publishing...",
            showLoadingConfirmationPublishBtns: true
        });

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard1")
        .doc("publishingData")
        .update({
            promoHeader: this.state.firstPromoText,
            promoSubheader: this.state.firstPromoSubtext,
            promoMiniText: this.state.firstPromoMiniText,
            promoMoreInfo: this.state.firstPromoMoreInfoText,
            promoImg: this.state.firstPromoImg,
            lastPublishedTime: formattedDateTimeWithAmPm
        })
        .then(() => {
            offerCard1Published = true
        })

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard2")
        .doc("publishingData")
        .update({
            promoHeader: this.state.secondPromoText,
            promoSubheader: this.state.secondPromoSubtext,
            promoMiniText: this.state.secondPromoMiniText,
            promoMoreInfo: this.state.secondPromoMoreInfoText,
            promoImg: this.state.secondPromoImg,
            lastPublishedTime: formattedDateTimeWithAmPm
        })
        .then(() => {
            offerCard2Published = true
        })

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard3")
        .doc("publishingData")
        .update({
            promoHeader: this.state.thirdPromoText,
            promoSubheader: this.state.thirdPromoSubtext,
            promoMiniText: this.state.thirdPromoMiniText,
            promoMoreInfo: this.state.thirdPromoMoreInfoText,
            promoImg: this.state.thirdPromoImg,
            lastPublishedTime: formattedDateTimeWithAmPm
        })
        .then(() => {
            offerCard3Published = true
        })

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .update({
            lastPublished: formattedDateTimeWithAmPm
        })

        await this.publishOfferCardsToMembers()

        if (offerCard1Published == true && offerCard2Published == true && offerCard3Published == true) {
            setTimeout(() => {
                this.setState({
                    showLoadingConfirmationPublishBtns: false,
                    confirmPublishBtnText: "Successfully published.",
                    lastPublishedTime: formattedDateTime,
                    showPublishSuccessMessage: true
                });
            }, 2000);
        } else {
            setTimeout(() => {
                this.setState({
                    showLoadingConfirmationPublishBtns: false,
                    confirmPublishBtnText: "Something went wrong",
                    lastPublishedTime: "",
                    showPublishNoSuccessMessage: true
                });
            }, 2000);
        }
    }

    confirmNoPublishClicked = () => {
        this.setState({
            showPreviewOfferCards: false,
            showConfirmPublishBtns: false,
            showOfferCardsPageLoading: true
          });
          setTimeout(() => {
            this.setState({
                showOfferCardsPageLoading: false,
                showOfferCardsSubheader: true,
                showOfferCards: true,
                showOfferCard1: true,
                showOfferCard2: true,
                showOfferCard3: true,
                showPublishBtn: true
            });
        }, 2500);
    }

    publishOfferCardsToMembers = async () => {

        const currentDate = new Date();

        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });

        const formattedDateTime = dateFormatter.format(currentDate);

        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';

        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard1")
        .doc("publishingData")
        .update({
            promoHeader: this.state.firstPromoText,
            promoSubheader: this.state.firstPromoSubtext,
            promoMiniText: this.state.firstPromoMiniText,
            promoMoreInfo: this.state.firstPromoMoreInfoText,
            promoImg: this.state.firstPromoImg,
            lastPublishedTime: formattedDateTimeWithAmPm
        })
        
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard2")
        .doc("publishingData")
        .update({
            promoHeader: this.state.secondPromoText,
            promoSubheader: this.state.secondPromoSubtext,
            promoMiniText: this.state.secondPromoMiniText,
            promoMoreInfo: this.state.secondPromoMoreInfoText,
            promoImg: this.state.secondPromoImg,
            lastPublishedTime: formattedDateTimeWithAmPm
        })
       
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard3")
        .doc("publishingData")
        .update({
            promoHeader: this.state.thirdPromoText,
            promoSubheader: this.state.thirdPromoSubtext,
            promoMiniText: this.state.thirdPromoMiniText,
            promoMoreInfo: this.state.thirdPromoMoreInfoText,
            promoImg: this.state.thirdPromoImg,
            lastPublishedTime: formattedDateTimeWithAmPm
        })
        

    }

    closePreviewOfferCardsClicked = () => {
        this.loadOfferCardsData()
        this.setState({
            showPreviewOfferCards: false,
            showConfirmPublishBtns: false,
            showOfferCardsPageLoading: true
          });
          setTimeout(() => {
            this.setState({
                showOfferCardsPageLoading: false,
                showOfferCardsSubheader: true,
                showOfferCards: true,
                showOfferCard1: true,
                showOfferCard2: true,
                showOfferCard3: true,
                showPublishBtn: true,
            });
        }, 2500);
    }

    goToPreviewPublish = () => {
        this.setState({
            showOfferCardsSubheader: false,
            showOfferCardAutosaveUnsaved: false,
            showOfferCard1: false,
            showOfferCard2: false,
            showOfferCard3: false,
            showPublishBtn: false,
            showOfferCardsPageLoading: true
          });
          setTimeout(() => {
            this.setState({
                showOfferCardsPageLoading: false,
                showPreviewOfferCards: true,
                showConfirmPublishBtns: true,
                showFinalConfirmPublishBtns: true,
                confirmPublishBtnText: "Are you sure you are ready to publish?",
                showPublishNoSuccessMessage: false,
                showPublishSuccessMessage: false,
            });
        }, 2500);
    }


    render () {

        let cardBackgroundColor = {
            backgroundColor: this.state.cardBackgroundColor
        }

        let referralInformationTitleStyle = {
            border: `${this.state.referralTitleBorderSize}px solid ${this.state.referralTitleBorderColor}`
        }

        let referralInformationTextStyle = {
            border: `${this.state.referralTextBorderSize}px solid ${this.state.referralTextBorderColor}`
        }

        return(
            <Styles>
                <div className='campaignFullPage'>
                    {this.state.showCampaignPageOptions && 
                        <div className='campaignsPage'>
                            {this.renderSelectedCampaignOptions()}
                            <div className='campaignOptionCategories'>
                                <h2 style={{fontFamily: "rubik", color: "black", fontSize: "30px"}}>Manage Customer-facing App</h2>
                                <div className='challengesContainer'>
                                    <div 
                                    className='challengeBox'
                                    onClick={this.challengeBox1Clicked}
                                    >
                                        <h1>💳</h1>
                                        <h4>(Card details)</h4>
                                        <h4>(Referral code information)</h4>
                                        {/* <h4>(Recent activity)</h4> */}
                                        <h2>Customer Information</h2>
                                    </div>
                                    <div 
                                    className='challengeBox'
                                    onClick={this.challengeBox2Clicked}
                                    >
                                        <h1>🎊</h1>
                                        <h4>(Offer cards)</h4>
                                        <h2>Latest Offers</h2>
                                    </div>
                                    {/* <div 
                                    className='challengeBox'
                                    onClick={this.challengeBox3Clicked}
                                    >
                                        <h1>🎁</h1>
                                        <h4>(Rewards)</h4>
                                        <h4>(Challenges)</h4>
                                        <h4>(Earning chart)</h4>
                                        <h4>(Wish list)</h4>
                                        <h4>(Secret menu)</h4>
                                        <h2>Rewards</h2>
                                    </div> */}
                                </div>
                                <h2 style={{fontFamily: "rubik", color: "black", fontSize: "30px"}}>Customer Outreach</h2>
                                <div className='challengesContainer'>
                                    <div 
                                    className='challengeBox2'
                                    onClick={this.challengeBox4Clicked}
                                    >
                                        <h1>📲</h1>
                                        <h2>WhatsApp <label className='innerChallengeBox2'>(coming soon)</label></h2>
                                    </div>
                                    <div
                                    className='challengeBox2'
                                    onClick={this.challengeBox5Clicked}
                                    >
                                        <h1>🖥</h1>
                                        <h2>Email <label className='innerChallengeBox2'>(coming soon)</label></h2>
                                    </div>
                                    <div 
                                    className='challengeBox2'
                                    onClick={this.challengeBox6Clicked}
                                    >
                                        <h1>📱</h1>
                                        <h2>SMS <label className='innerChallengeBox2'>(coming soon)</label></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.showOfferCards && 
                        <div>
                            <div style={{display: "flex", justifyContent: "space-between", marginRight: "7.75%"}}>
                                {this.state.showOfferCardsSubheader && 
                                    <h2 style={{fontFamily: "arvo", color: "#0930cb", marginBottom: "0.75%"}}>↳ Editing Mode - <label style={{fontSize: "75%", fontFamily: "rubik"}}>Click on a card to start making edits</label></h2>
                                }
                                <div>
                                {this.state.showOfferCardAutosaveUnsaved && 
                                    <div style={{marginTop: "1%"}} className='offerCardAutosave'>
                                        {this.state.showChangesDetectedLabel && <p>Last updated at <label>{this.state.offerCardAutosaveLatestTime}</label></p>}
                                        {this.state.showChangesDetectedLoading && 
                                            <div style={{marginTop: "27.5%", marginRight: "50px"}} className='loadingAutosave'>
                                                <ClipLoader
                                                color="#0930CB"
                                                loading={true}
                                                // cssOverride={override}
                                                size={14}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        } 
                                    </div>
                                }
                                </div>
                            </div>
                            <div style={{marginTop: "0.85%"}} className='latestOfferCards'>
                                {/* <div className='previewOfferCardsHeader'>
                                    <h2>↳ Design Mode</h2>
                                </div> */}
                                {this.state.showOfferCard1 && 
                                    <div className='offerCard'>
                                        {/* <h2><u>Coffee O'Clock</u></h2> */}
                                        <div className='offerCardHeader'>
                                            <input 
                                            id='firstPromoText'
                                            onChange={this.handleChange}
                                            value={this.state.firstPromoText}
                                        />
                                        </div>
                                        <div className='offerCardLabel'>
                                            {/* <label>Get 1 FREE coffee</label> */}
                                            <input 
                                            id='firstPromoSubtext'
                                            onChange={this.handleChange}
                                            value={this.state.firstPromoSubtext}
                                            />
                                        </div>
                                        <div className='offerCardBtn'>
                                            <button
                                            onClick={this.moreInfoCard1Clicked}
                                            >More info</button>
                                        </div>
                                        <h4>OR</h4>
                                        {/* <p><span>☕️</span>Get a free coffee for 100 points</p> */}
                                        <div className='offerCardLastPromoText'>
                                            <input
                                            id='firstPromoMiniText'
                                            onChange={this.handleChange}
                                            value={this.state.firstPromoMiniText}
                                            />
                                        </div>
                                        <div className='offerCardUploadImage'>
                                            <button
                                            onClick={this.handleFileInputCard1}
                                            >Upload Image</button>
                                            <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            ref={(input) => (this.fileInput1 = input)} // Reference to the hidden input
                                            onChange={(e) => this.handleImageUploadOfferCard1(e.target.files[0])}
                                            />
                                        </div>
                                        {this.state.showOfferCard1Img && 
                                            <div className='offerCardImgDiv'>
                                                <img src={this.state.firstPromoImg}/> 
                                                <h5 style={{marginBottom: "0.5%"}}>Optimal Image Dimensions: 500x300</h5>
                                                <h5 style={{marginTop: "0.5%"}}>Set Img Background Color to #321d05</h5>
                                            </div>
                                        }
                                        {this.state.showOfferCard1ImgLoading && 
                                            <div className='loadingOfferCardImg'>
                                                <ClipLoader
                                                color="#fff"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.showOfferCard1DisplayLoading && 
                                    <div className='offerCard'>
                                        <div className='loadingMoreCardInfo'>
                                            <ClipLoader
                                            color="white"
                                            loading={true}
                                            // cssOverride={override}
                                            size={45}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                }
                                {this.state.showOfferCard1MoreInfo && 
                                    <div className='offerCardMoreInfo'>
                                        <h3>More details</h3>
                                        <div>
                                            <textarea
                                            id='firstPromoMoreInfoText'
                                            onChange={this.handleChange}
                                            value={this.state.firstPromoMoreInfoText}
                                            />
                                        </div>
                                        <button
                                        onClick={this.closeMoreInfoCard1Clicked}
                                        >Close</button>
                                    </div>
                                }
                                {this.state.showOfferCard1MoreInfoLoading && 
                                    <div className='offerCardMoreInfo'>
                                        <div className='loadingMoreCardInfo'>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={30}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                }
                                {this.state.showOfferCard2 && 
                                    <div className='offerCard'>
                                        <div className='offerCardHeader'>
                                            <input 
                                            id='secondPromoText'
                                            onChange={this.handleChange}
                                            value={this.state.secondPromoText}
                                            />
                                        </div>
                                        <div className='offerCardLabel'>
                                            {/* <label>Get 1 FREE coffee</label> */}
                                            <input 
                                            id='secondPromoSubtext'
                                            onChange={this.handleChange}
                                            value={this.state.secondPromoSubtext}
                                            />
                                        </div>
                                        <div className='offerCardBtn'>
                                            <button
                                            onClick={this.moreInfoCard2Clicked}
                                            >More info</button>
                                        </div>
                                        <h4>OR</h4>
                                        {/* <p><span>☕️</span>Get a free coffee for 100 points</p> */}
                                        <div className='offerCardLastPromoText'>
                                            <input
                                            id='secondPromoMiniText'
                                            onChange={this.handleChange}
                                            value={this.state.secondPromoMiniText}
                                            />
                                        </div>
                                        <div className='offerCardUploadImage'>
                                            <button
                                            onClick={this.handleFileInputCard2}
                                            >Upload Image</button>
                                            <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            ref={(input) => (this.fileInput2 = input)} // Reference to the hidden input
                                            onChange={(e) => this.handleImageUploadOfferCard2(e.target.files[0])}
                                            />
                                        </div>
                                        {this.state.showOfferCard2Img && 
                                            <div className='offerCardImgDiv'>
                                                <img src={this.state.secondPromoImg}/> 
                                                <h5 style={{marginBottom: "0.5%"}}>Optimal Image Dimensions: 500x300</h5>
                                                <h5 style={{marginTop: "0.5%"}}>Set Img Background Color to #321d05</h5>
                                            </div>
                                        }
                                        {this.state.showOfferCard2ImgLoading && 
                                            <div className='loadingOfferCardImg'>
                                                <ClipLoader
                                                color="#fff"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.showOfferCard2DisplayLoading && 
                                    <div className='offerCard'>
                                        <div className='loadingMoreCardInfo'>
                                            <ClipLoader
                                            color="white"
                                            loading={true}
                                            // cssOverride={override}
                                            size={45}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                }
                                {this.state.showOfferCard2MoreInfo && 
                                    <div className='offerCardMoreInfo'>
                                        <h3>More details</h3>
                                        <div>
                                            <textarea
                                            id='secondPromoMoreInfoText'
                                            onChange={this.handleChange}
                                            value={this.state.secondPromoMoreInfoText}
                                            />
                                        </div>
                                        <button
                                        onClick={this.closeMoreInfoCard2Clicked}
                                        >Close</button>
                                    </div>
                                }
                                {this.state.showOfferCard2MoreInfoLoading && 
                                    <div className='offerCardMoreInfo'>
                                        <div className='loadingMoreCardInfo'>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={30}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                }
                                {this.state.showOfferCard3 && 
                                    <div className='offerCard'>
                                        <div className='offerCardHeader'>
                                            <input 
                                            id='thirdPromoText'
                                            onChange={this.handleChange}
                                            value={this.state.thirdPromoText}
                                            />
                                        </div>
                                        <div className='offerCardLabel'>
                                            {/* <label>Get 1 FREE coffee</label> */}
                                            <input 
                                            id='thirdPromoSubtext'
                                            onChange={this.handleChange}
                                            value={this.state.thirdPromoSubtext}
                                            />
                                        </div>
                                        <div className='offerCardBtn'>
                                            <button
                                            onClick={this.moreInfoCard3Clicked}
                                            >More info</button>
                                        </div>
                                        <h4>OR</h4>
                                        {/* <p><span>☕️</span>Get a free coffee for 100 points</p> */}
                                        <div className='offerCardLastPromoText'>
                                            <input
                                            id='thirdPromoMiniText'
                                            onChange={this.handleChange}
                                            value={this.state.thirdPromoMiniText}
                                            />
                                        </div>
                                        <div className='offerCardUploadImage'>
                                            <button
                                            onClick={this.handleFileInputCard3}
                                            >Upload Image</button>
                                            <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            ref={(input) => (this.fileInput3 = input)} // Reference to the hidden input
                                            onChange={(e) => this.handleImageUploadOfferCard3(e.target.files[0])}
                                            />
                                        </div>
                                        {this.state.showOfferCard3Img && 
                                            <div className='offerCardImgDiv'>
                                                <img src={this.state.thirdPromoImg}/> 
                                                <h5 style={{marginBottom: "0.5%"}}>Optimal Image Dimensions: 500x300</h5>
                                                <h5 style={{marginTop: "0.5%"}}>Set Img Background Color to #321d05</h5>
                                            </div>
                                        }
                                        {this.state.showOfferCard3ImgLoading && 
                                            <div className='loadingOfferCardImg'>
                                                <ClipLoader
                                                color="#fff"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.showOfferCard3DisplayLoading && 
                                    <div className='offerCard'>
                                        <div className='loadingMoreCardInfo'>
                                            <ClipLoader
                                            color="white"
                                            loading={true}
                                            // cssOverride={override}
                                            size={45}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                }
                                {this.state.showOfferCard3MoreInfo && 
                                    <div className='offerCardMoreInfo'>
                                        <h3>More details</h3>
                                        <div>
                                            <textarea
                                            id='thirdPromoMoreInfoText'
                                            onChange={this.handleChange}
                                            value={this.state.thirdPromoMoreInfoText}
                                            />
                                        </div>
                                        <button
                                        onClick={this.closeMoreInfoCard3Clicked}
                                        >Close</button>
                                    </div>
                                }
                                {this.state.showOfferCard3MoreInfoLoading && 
                                    <div className='offerCardMoreInfo'>
                                        <div className='loadingMoreCardInfo'>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={30}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                            {this.state.showPreviewOfferCards && 
                                <div className='previewOfferCards'>
                                    <div className='previewOfferCardsHeader'>
                                        <h2>↳ Preview Mode - <label style={{fontSize: "75%", fontFamily: "rubik"}}>Verify everything is okay before publishing</label></h2>
                                        <button
                                        onClick={this.closePreviewOfferCardsClicked}
                                        >Close Preview</button>
                                    </div>
                                    {this.state.showPreviewCard1 && 
                                        <div className='previewOfferCard'>
                                            <h2><u>{this.state.firstPromoText}</u></h2>
                                            <div className='offerCardLabel'>
                                                <label>{this.state.firstPromoSubtext}</label>
                                            </div>
                                            <div className='offerCardBtn'>
                                                <button
                                                onClick={this.previewMoreInfoCard1Clicked}
                                                >More info</button>
                                            </div>
                                            <h4>OR</h4>
                                            <p>{this.state.firstPromoMiniText}</p>
                                            <img src={this.state.firstPromoImg}/> 
                                        </div>
                                    }
                                    {this.state.showPreviewCard1Loading && 
                                        <div className='previewOfferCardMoreInfo'>
                                            <div className='previewOfferCardLoading'>
                                                <ClipLoader
                                                color="#321d05"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        </div>
                                    }
                                    {this.state.showPreviewCard1MoreInfo && 
                                        <div className='previewOfferCardMoreInfo'>
                                            <h3>More details</h3>
                                            <div>
                                                <textarea
                                                id='secondPromoMoreInfoText'
                                                // onChange={this.handleChange}
                                                value={this.state.firstPromoMoreInfoText}
                                                />
                                            </div>
                                            <button
                                            onClick={this.closePreviewMoreInfoCard1Clicked}
                                            >Close</button>
                                        </div>
                                    }
                                    {this.state.showPreviewCard2 && 
                                        <div className='previewOfferCard'>
                                            <h2><u>{this.state.secondPromoText}</u></h2>
                                            <div className='offerCardLabel'>
                                                <label>{this.state.secondPromoSubtext}</label>
                                            </div>
                                            <div className='offerCardBtn'>
                                                <button
                                                onClick={this.previewMoreInfoCard2Clicked}
                                                >More info</button>
                                            </div>
                                            <h4>OR</h4>
                                            <p>{this.state.secondPromoMiniText}</p>
                                            <img src={this.state.secondPromoImg}/> 
                                        </div>
                                    }
                                    {this.state.showPreviewCard2Loading &&
                                        <div className='previewOfferCardMoreInfo'>
                                            <div className='previewOfferCardLoading'>
                                                <ClipLoader
                                                color="#321d05"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        </div>
                                    }
                                    {this.state.showPreviewCard2MoreInfo && 
                                        <div className='previewOfferCardMoreInfo'>
                                            <h3>More details</h3>
                                            <div>
                                                <textarea
                                                id='secondPromoMoreInfoText'
                                                // onChange={this.handleChange}
                                                value={this.state.secondPromoMoreInfoText}
                                                />
                                            </div>
                                            <button
                                            onClick={this.closePreviewMoreInfoCard2Clicked}
                                            >Close</button>
                                        </div>
                                    }
                                    {this.state.showPreviewCard3 && 
                                        <div className='previewOfferCard'>
                                            <h2><u>{this.state.thirdPromoText}</u></h2>
                                            <div className='offerCardLabel'>
                                                <label>{this.state.thirdPromoSubtext}</label>
                                            </div>
                                            <div className='offerCardBtn'>
                                                <button
                                                onClick={this.previewMoreInfoCard3Clicked}
                                                >More info</button>
                                            </div>
                                            <h4>OR</h4>
                                            <p>{this.state.thirdPromoMiniText}</p>
                                            <img src={this.state.thirdPromoImg}/> 
                                        </div>
                                    }
                                    {this.state.showPreviewCard3Loading && 
                                        <div className='previewOfferCardMoreInfo'>
                                            <div className='previewOfferCardLoading'>
                                                <ClipLoader
                                                color="#321d05"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        </div>
                                    }
                                    {this.state.showPreviewCard3MoreInfo && 
                                        <div className='previewOfferCardMoreInfo'>
                                            <h3>More details</h3>
                                            <div>
                                                <textarea
                                                id='secondPromoMoreInfoText'
                                                // onChange={this.handleChange}
                                                value={this.state.thirdPromoMoreInfoText}
                                                />
                                            </div>
                                            <button
                                            onClick={this.closePreviewMoreInfoCard3Clicked}
                                            >Close</button>
                                        </div>
                                    }
                                </div>
                            }
                            {this.state.showPublishBtn && 
                                <div style={{display: "flex", justifyContent: "space-between"}} className='offerCardsBtns'>
                                    <h3 style={{marginBottom: "0px", marginTop: "1%", color: "#8A8A8A", fontFamily: "gabarito", marginRight: "0.5%"}}>Last published: <label style={{color: "black"}}>{this.state.lastPublishedDisplay}</label></h3>
                                    
                                    {this.state.showPublishRealBtn && 
                                        <button
                                        onClick={this.goToPreviewPublish}
                                        >Publish</button>
                                    }
                                    {this.state.showPublishLoadingBtn && 
                                        <button>
                                            <ClipLoader
                                            color="#fff"
                                            loading={true}
                                            // cssOverride={override}
                                            size={10}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </button>
                                    }
                                </div>
                            }
                            {this.state.showConfirmPublishBtns && 
                                <div className='offerCardConfirmationBtn'>
                                    <h3>{this.state.confirmPublishBtnText}</h3>
                                    {this.state.showFinalConfirmPublishBtns && 
                                        <div>
                                            <button 
                                            className='offerCardConfirmationNoBtn'
                                            onClick={this.confirmNoPublishClicked}
                                            >No</button>
                                            <button 
                                            className='offerCardConfirmationYesBtn'
                                            onClick={this.confirmYesPublishClicked}
                                            >Yes</button>
                                        </div>
                                    }
                                    {this.state.showLoadingConfirmationPublishBtns && 
                                        <div className='loadingFinalPublishBtns'>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={20}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                    {this.state.showPublishSuccessMessage && 
                                        <div className='publishSuccessMessage'>
                                            <h1>Last updated: <label>{this.state.lastPublishedTime}</label></h1>
                                            <img src='/assets/checkmark_publishedOffers.png'/>
                                        </div>
                                    }

                                    {this.state.showPublishNoSuccessMessage && 
                                        <div className='publishSuccessMessage'>
                                            <h1>Publish Unsuccessful: <label>{this.state.lastPublishedTime}</label></h1>
                                            <img src='/assets/cross_publishedOffers.png'/> <br/>
                                            <p></p>
                                        </div>
                                    }
                                </div>
                            }
                            {this.state.showOfferCardsPageLoading && 
                                <div className='offerCardsPageLoading'>
                                    <ClipLoader
                                    color="#0930cb"
                                    loading={true}
                                    // cssOverride={override}
                                    size={30}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                    />
                                </div>
                            }
                        </div>
                    }
                    {this.state.showCampaignsPageLoading && 
                        <div className='loadingOfferCardImg'>
                            <ClipLoader
                            color="#0930cb"
                            loading={true}
                            // cssOverride={override}
                            size={30}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                    {this.state.showCustomerInformation && 
                        <div className='customerInformation'>
                            <h2 style={{color: "black", fontFamily: "rubik", fontSize: "30px"}}>Card information</h2>
                            <div className='customerInfoSection'>
                                <div className='customerInfoSectionCol'>
                                        <div style={cardBackgroundColor} className='userPointsCard'>
                                            {this.state.showUserLoyaltyCard && 
                                                <div>
                                                    <h4>Loyalty Card</h4>
                                                    <h3>FIRST NAME + LAST NAME</h3>
                                                    <div className='userPointsCardInnerContainer'>
                                                        <div className='userPointsCardIcon'>
                                                            <img src={this.state.cardPointsLogo}/>
                                                        </div>
                                                        <div className='userPointsCardDetails'>
                                                            <h1>1350 Points</h1>
                                                            {this.state.showCardPointsTillReward && 
                                                                <p>550 points till your next reward</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className='userPointsCardFooter'>
                                                        <div className='userPointsCardLogo'>
                                                            <img src={this.state.cardCompanyLogo}/>
                                                        </div>
                                                        <div className='userPointsCardNumber'>
                                                            {this.state.showCardUserNumber && 
                                                                <p>123 4567 89000</p>
                                                            }
                                                        </div>
                                                    </div>
                                                </div> 
                                            }
                                            {this.state.showUserLoyaltyCardLoading && 
                                                <div className='userLoyaltyCardLoading'>
                                                    <ClipLoader
                                                    color="#0930CB"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={20}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                    />
                                                </div>
                                            }
                                            {this.state.showUserLoyaltyCardNoConnection && 
                                                <div className='userLoyaltyCardNoConnection'>
                                                    <img src='assets/no-internet.png'/>
                                                </div>
                                            }
                                        </div>
                                    
                                </div>
                                <div className='customerInfoSectionCol2'>
                                    <div className='loyaltyCardSettings'>
                                        <div className='settingSection'>  
                                            <div className='settingCheckmark'>
                                                {this.state.showCardSetting1Unchecked && 
                                                    <img 
                                                    onClick={this.cardSetting1UncheckedClicked}
                                                    src='assets/earningPolicyUnchecked.png'/>
                                                }
                                                {this.state.showCardSetting1Checked && 
                                                    <img 
                                                    onClick={this.cardSetting1CheckedClicked}
                                                    src='assets/earningPolicyChecked.png'/>
                                                }
                                            </div>
                                            <div className='settingDescription'>
                                                <p>Show points remaining till next reward</p>
                                            </div>
                                        </div>
                                        <div className='settingSection'>  
                                            <div className='settingCheckmark'>
                                                {this.state.showCardSetting2Unchecked && 
                                                    <img 
                                                    onClick={this.cardSetting2UncheckedClicked}
                                                    src='assets/earningPolicyUnchecked.png'/>
                                                }
                                                {this.state.showCardSetting2Checked && 
                                                    <img 
                                                    onClick={this.cardSetting2CheckedClicked}
                                                    src='assets/earningPolicyChecked.png'/>
                                                }
                                            </div>
                                            <div className='settingDescription'>
                                                <p>Show loyalty card number</p>
                                            </div>
                                        </div>
                                        <div className='cardColorPicker'>
                                            <h4>Change card background color:</h4>
                                            <GithubPicker
                                            color={this.state.cardBackgroundColor}
                                            onChange={this.handleCardColorChange}
                                            />
                                            <button
                                            onClick={this.resetColorPickerClicked}
                                            >Reset</button>
                                        </div>
                                        {this.state.showUserLoyaltyCardConfirmationBtns && 
                                            <div className='userLoyaltyCardConfirmationBtns'>
                                                <h4>Are you ready to publish?</h4>
                                                <button
                                                className='userLoyaltyCardNoConfirmBtn'
                                                onClick={this.userLoyaltyNoConfirmationClicked}
                                                >No</button>
                                                <button
                                                className='userLoyaltyCardYesConfirmBtn'
                                                onClick={this.userLoyaltyYesConfirmationClicked}
                                                >Yes</button>
                                            </div>
                                        }
                                        {this.state.showUserLoyaltyConfirmationLoading && 
                                            <div className='userLoyaltyConfirmationLoading'>
                                                <ClipLoader
                                                color="#0930CB"
                                                loading={true}
                                                // cssOverride={override}
                                                size={20}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                        {this.state.showUserLoyaltySuccessMessage &&
                                            <div className='userLoyaltyCardSuccessMessage'>
                                                <div className='publishSuccessMessage'>
                                                    <h1>Last updated: <label>{this.state.userLoyaltyLastPublishedTime}</label></h1>
                                                    <img src='/assets/checkmark_publishedOffers.png'/>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showUserLoyaltyNoSuccessMessage &&
                                            <div className='userLoyaltyCardSuccessMessage'>
                                                <div className='publishSuccessMessage'>
                                                    <h1>Not updated: <label>{this.state.userLoyaltyLastPublishedTime}</label></h1>
                                                    <img src='/assets/cross_publishedOffers.png'/>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {this.state.showUserLoyaltyCardPublishBtn && 
                                        <div className='customerInfoSectionPublishBtn'>
                                            <button
                                            onClick={this.userLoyaltyPublishBtnClicked}
                                            >Publish</button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='customerInformationSeparator'></div>
                            <h2 style={{color: "black", fontFamily: "rubik", fontSize: "30px"}}>Referral code sharing</h2>
                            <div className='customerInfoSection'>
                                <div className='customerInfoSectionCol'>
                                    <div className='invitationCard'>
                                        {this.state.showInvitationCard && 
                                            <div>
                                                <h2>{this.state.invitationCardHeader}</h2>
                                                <p>{this.state.invitationCardText}</p>
                                                <div className='invitationCardBtn'>
                                                    <button
                                                    >Share Code</button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showInvitationCardLoading && 
                                            <div className='invitationCardLoading'>
                                                <ClipLoader
                                                color="#0930CB"
                                                loading={true}
                                                // cssOverride={override}
                                                size={20}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className='referralPolicyInformation'>
                                        <p>Current referral earning policy:</p>
                                        <h2>{this.state.referralPolicyReferralCount} referral = {this.state.referralPolicyPoints} points</h2>
                                    </div>
                                </div>
                                <div className='customerInfoSectionCol2'>
                                    <div className='loyaltyCardSettings'>
                                        <div className='referralCodeDetails'>
                                            <h4>Title</h4>
                                            <input
                                            style={referralInformationTitleStyle}
                                            id='invitationCardHeader'
                                            value={this.state.invitationCardHeader}
                                            onChange={this.handleReferralChange}
                                            />
                                            <h4>Referral information</h4>
                                            <textarea
                                            style={referralInformationTextStyle}
                                            id='invitationCardText'
                                            value={this.state.invitationCardText}
                                            onChange={this.handleReferralChange}
                                            />
                                            {this.state.showReferralErrorMsg1 && 
                                                <h5>⚠️  Title cannot be blank</h5>
                                            }
                                            {this.state.showReferralErrorMsg2 && 
                                                <h5>⚠️  Referral information cannot be blank</h5>
                                            }
                                            {this.state.showReferralErrorMsg3 && 
                                                <h5>⚠️  Referral information MUST include "{this.state.referralPolicyPoints} points" somewhere in text</h5>
                                            }
                                            {this.state.showInvitationCardConfirmationBtns && 
                                                <div className='invitationCardConfirmationBtns'>
                                                    <h4>Are you ready to publish?</h4>
                                                    <button
                                                    className='userLoyaltyCardNoConfirmBtn'
                                                    onClick={this.invitationCardNoConfirmationClicked}
                                                    >No</button>
                                                    <button
                                                    className='userLoyaltyCardYesConfirmBtn'
                                                    onClick={this.invitationCardYesConfirmationClicked}
                                                    >Yes</button>
                                                </div>
                                            }
                                            {this.state.showInvitationCardConfirmationLoading && 
                                                <div className='invitationCardConfirmationLoading'>
                                                    <ClipLoader
                                                    color="#0930CB"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={20}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                    />
                                                </div>
                                            }
                                            {this.state.showInvitationCardSuccessMessage && 
                                                <div className='invitationCardConfirmationSuccessMessage'>
                                                    <div className='publishSuccessMessage'>
                                                        <h1>Last updated: <label>{this.state.invitationCardLastPublishedTime}</label></h1>
                                                        <img src='/assets/checkmark_publishedOffers.png'/>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showInvitationCardNoSuccessMessage && 
                                                <div className='invitationCardConfirmationSuccessMessage'>
                                                    <div className='publishSuccessMessage'>
                                                        <h1>Not published: <label>{this.state.invitationCardLastPublishedTime}</label></h1>
                                                        <img src='/assets/cross_publishedOffers.png'/>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {this.state.showInvitationCardPublishBtn && 
                                        <div className='customerInfoSectionPublishBtn'>
                                            <button
                                            onClick={this.invitationCardPublishBtnClicked}
                                            >Publish</button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div style={{borderBottom: "1px solid white"}} className='customerInformationSeparator'></div>
                            {/* <h2>Recent activity</h2>
                            <div className='customerInfoSection'>
                                <div className='customerInfoSectionCol'>
                                    <div className='recentActivityCampaign'>
                                        <div className='recentActivityCellCampaign'>
                                            {this.state.showRecentActivityCard && 
                                                <div>
                                                    <div className='recentActivityImgCampaign'>
                                                        <img src={this.state.recentActivityLogo}/>
                                                    </div>
                                                    <div className='recentActivityDetailsCampaign'>
                                                        <h5>+ Cappuccino (KES 270)</h5>
                                                        <p>📍 Artcaffe, The Hub</p>
                                                        <label>🧾 {this.state.recentActivityTimestamp}</label>
                                                    </div>
                                                    <div className='recentActivityTimestampCampaign'>
                                                    <h4>
                                                        <span>↑ </span>
                                                        <CountUp
                                                            start={0}
                                                            end={1000}
                                                            duration={2}
                                                            useEasing={true}
                                                            useGrouping={true}
                                                            separator={''}
                                                            decimal={'.'}
                                                        />
                                                        <span> pts</span>
                                                    </h4>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showRecentActivityCardLoading && 
                                                <div className='recentActivityCellCampaignLoading'>
                                                    <ClipLoader
                                                    color="#0930CB"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={25}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                    />
                                                </div>
                                            }
                                        </div>
                                        {/* <div className='recentActivityCell'>
                                            <div className='recentActivityImg'>
                                                <img src='/assets/recent-activity6.5.gif'/>
                                            </div>
                                            <div className='recentActivityDetails'>
                                                <h5>+ Art Rose Hibiscus Iced Tea (KES 390) </h5>
                                                <p>📍 Artcaffe, The Hub</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='customerInfoSectionCol2'>
                                    <div className='loyaltyCardSettings'>
                                        <h2>Nothing to edit here currently</h2>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}